import { createAction, props } from '@ngrx/store';
import { AgencyOfficerDetails, AgencyOfficerDetailsPermissions, OfficerPermissions } from '../models/officer-details.models';
import { AgencyOfficerDetailsRequest, OfficerPersmissionsRequest } from '../models/officer-details-request.models';
import { UpdateOfficerDetailsPermissionsActionResult } from '../models/officer-details-action-result.models';

export const clearState = createAction('[AgencyOfficerDetails] clearState');

export const fetchAgencyOfficerDetails = createAction('[AgencyOfficerDetails] Fetch Agency Officer Details', props<{ uid: string }>());
export const fetchAgencyOfficerDetailsSuccess = createAction(
  '[AgencyOfficerDetails] Fetch Agency Officer Details Success',
  props<{ agencyOfficerDetailsPermissions: AgencyOfficerDetailsPermissions }>()
);

export const updateAgencyOfficerDetails = createAction('[AgencyOfficerDetails] Update Agency Officer Details', props<{ agencyOfficerDetails: AgencyOfficerDetailsRequest }>());
export const updateAgencyOfficerDetailsSuccess = createAction(
  '[AgencyOfficerDetails] Update Agency Officer Details Success',
  props<{ agencyOfficerDetails: AgencyOfficerDetails }>()
);

export const updateAgencyOfficerPermissions = createAction(
  '[AgencyOfficerDetails] Update Agency Officer Permissions',
  props<{ agencyOfficerPermissions: OfficerPersmissionsRequest }>()
);
export const updateAgencyOfficerPermissionsSuccess = createAction(
  '[ActionOfficerDetails] Update Agency Officer Permissions Success',
  props<{ agencyOfficerPermissions: OfficerPermissions }>()
);

export const updateAgencyOfficerPhoto = createAction('[AgencyOfficerDetails] Update Agency Officer Photo', props<{ photo: File }>());
export const updateAgencyOfficerPhotoSuccess = createAction('[AgencyOfficerDetails] Update Agency Officer Photo Success', props<{ newUrl: string }>());
export const updateAgencyOfficerPhotoFailure = createAction('[AgencyOfficerDetails] Update Agency Officer Photo Failure');

export const updateAgencyOfficerActionResult = createAction(
  '[AgencyOfficerDetails] Update Agency Officer Action Result',
  props<{ actionResult: UpdateOfficerDetailsPermissionsActionResult }>()
);
